import React, { useContext, useEffect, useRef, useState } from "react";
import { ERROR_MESSAGES } from "./GlobalMassssage";
import Select from "react-select";

import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import {
  GetQueryModel,
  UpdateQueryRemark,
  UpdateRemark,
} from "../../services/CustomerQuaries/CUstomerQuariesApi";
import SuccessModal from "./SuccessModal";

const SolveQueryModal = ({
  isOpen,
  onClose,
  setIsAddUpdateDone,
  modelRequestData,
}) => {
  const inputRef = useRef(null);
  const ModuleName = "Predefined";
  const [remark, setRemark] = useState("");
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const [customerIndustryID, setCustomerIndustryID] = useState("");
  const { authDetails } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);
  const [customerIndustryOptions, setcustomerIndustryOptions] = useState([]);

  //getModel
  useEffect(() => {
    setModelAction(modelRequestData.Action === null ? "Add" : "Update"); //Do not change this naming convention
    if (
      modelRequestData.KeyID !== undefined &&
      modelRequestData.KeyID !== null &&
      modelRequestData.Action === "Update"
    ) {
      // GetRemarkModelData(modelRequestData.KeyID);
    }
    setErrorMessage("");
  }, [modelRequestData]);
  if (!isOpen) return null;

  //Get Model
  const GetRemarkModelData = async (KeyID) => {
    setLoader(true);
    const data = await GetQueryModel(KeyID, authDetails.adminKeyID);
    if (data.statusCode === 200) {
      setLoader(false);
      const ModalData = data.responseData.data;
      setRemark(ModalData.remark);
    } else {
      setLoader(false);
    }
  };
  const handleRemarkUpdate = async () => {
    if (remark === undefined || remark === null || remark === "") {
      setRequireErrorMessage(true);
      return false;
    }
    setLoader(true);
    try {
      const data = await UpdateQueryRemark({
        adminKeyID: authDetails.adminKeyID,
        remark: remark,
        queryKeyID: modelRequestData.KeyID,
      });
      if (data?.statusCode === 200) {
        setLoader(false);
        setIsAddUpdateDone(true);
        // onClose(); // Close the StaffRoleModal
        setShowSuccessPopupModal(true); // Show the SuccessModal
      } else {
        setLoader(false);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  return (
    <>
      <div
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
        onClick={onClose}
        aria-hidden={!isOpen}
      >
        <div
          className="bg-white rounded-lg shadow-lg w-full max-w-md"
          role="dialog"
          aria-modal="true"
          onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
        >
          {/* Modal Header */}
          <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
            <h2 className="text-16 font-semibold">{modelAction} Quary</h2>
            <button
              className="text-gray-500 hover:text-gray-700"
              onClick={onClose}
              aria-label="Close Modal"
            >
              ✕
            </button>
          </div>

          {/* Modal Body */}
          <div className="p-6 grid grid-cols-1 gap-2">
            {" "}
            {/* Change gap-4 to gap-0 */}
            {/* Role Name Input */}
            <div className="mb-0 w-full">
              {" "}
              {/* Change mb-4 to mb-0 */}
              <label className="block text-12 text-gray-700 mb-1">
                Remark<span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                type="text"
                maxLength={20}
                className="w-full p-2 border rounded-md text-12"
                placeholder="Enter Remark"
                value={remark}
                onChange={(e) => {
                  let value = e.target.value;

                  // Capitalize the first letter if the input is not empty
                  if (value.length > 0) {
                    value = value.charAt(0).toUpperCase() + value.slice(1);
                  }

                  // Allow only letters at the start, then letters & spaces after the first character
                  if (/^[A-Za-z][A-Za-z\s]*$/.test(value) || value === "") {
                    setRemark(value);
                  }
                }}
              />
              {requireErrorMessage &&
              (remark === "" || remark === undefined || remark === null) ? (
                <label className="validation">{ERROR_MESSAGES}</label>
              ) : (
                ""
              )}
            </div>
          </div>

          {errorMessage && (
            <div className="text-center mb-2">
              <label className="validation ">{errorMessage}</label>
            </div>
          )}

          {/* Modal Footer */}
          <div className="bg-gray-100 px-6 py-4 border-t flex justify-end gap-3">
            <button
              type="button"
              className="px-4 py-2 bg-gray-300 rounded-md text-12"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              onClick={() => handleRemarkUpdate()}
              className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12"
            >
              Submit
            </button>
          </div>
        </div>

        <SuccessModal
          isOpen={showSuccessPopupModal}
          onClose={() => {
            onClose();
            setShowSuccessPopupModal(false);
          }}
          // modelAction={modelAction}
          actionMessage={remark}
        />
      </div>
    </>
  );
};

export default SolveQueryModal;
